import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ship, GraduationCap, ArrowUpRight } from "lucide-react";
import { api } from "../../context/AuthContext";

const STATS = [
  { value: "9K+", label: "Active seafarers" },
  { value: "400+", label: "Shipping companies" },
  { value: "110+", label: "Maritime institutes" },
  { value: "1.5K", label: "Job posts / month" },
];

const BADGE = "mx-3 inline-flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-full border px-5 py-2.5 text-sm font-semibold transition-colors";

const MarqueeItem = ({ name, type, org_id, hidden }) => {
  const Icon = type === "fleet" ? Ship : GraduationCap;
  const inner = <><Icon className="h-4 w-4 text-[#FF4500]" /> {name}</>;
  if (org_id) {
    return (
      <Link to={`/org/${org_id}`} tabIndex={hidden ? -1 : undefined} aria-hidden={hidden || undefined} data-testid={hidden ? undefined : `partner-link-${org_id}`}
        className={`${BADGE} border-orange-200 bg-white text-slate-800 hover:border-[#FF4500] hover:text-[#FF4500]`}>
        {inner} <ArrowUpRight className="h-3.5 w-3.5 opacity-60" />
      </Link>
    );
  }
  return <span aria-hidden={hidden || undefined} className={`${BADGE} border-stone-200 bg-stone-50/80 text-slate-600`}>{inner}</span>;
};

export const StatsStrip = () => {
  const [partners, setPartners] = useState([]);
  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data.partners)).catch(() => {});
  }, []);

  return (
    <section id="fleets" className="border-y border-stone-200/80 bg-white py-14 sm:py-20" data-testid="landing-stats">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-slate-400" data-testid="trusted-heading">Trusted by crew from leading fleets and maritime institutes</p>
      </div>
      <div className="indos-marquee mt-8 overflow-hidden" data-testid="trusted-marquee">
        <div className="indos-marquee-track">
          {partners.map((p) => <MarqueeItem key={p.id} {...p} />)}
          {partners.map((p) => <MarqueeItem key={`dup-${p.id}`} {...p} hidden />)}
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <div key={s.label} className="indos-reveal rounded-2xl border border-stone-200/80 bg-stone-50/70 p-7 text-center transition-colors hover:border-orange-200 hover:bg-orange-50/30"
              style={{ animationDelay: `${i * 80}ms` }} data-testid={`landing-stat-${i}`}>
              <span className="font-heading block text-4xl font-extrabold tracking-tight text-[#FF4500] sm:text-5xl">{s.value}</span>
              <span className="mt-2 block text-sm font-medium text-slate-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
